<template>
  <!-- prettier-ignore -->
  <div
    class="tabs"
    :class="{ 'tabs--empty': persons.length === 0 }">
    <div
      v-if="activePerson"
      class="tabs-person"
      @click="toggle">
      <ovp-pw-tab
        :person="activePerson"
        selected
        @select="$personId => $emit('select', $personId)"
      />

      <ovp-icon
        art="light"
        :flip="toggled ? 'vertical' : 'horizontal'"
        name="angle-down"
      />
    </div>

    <template v-if="persons.length > 0">
      <transition name="tabs">
        <div
          v-if="toggled || $browser.isDesktop"
          class="tabs-list"
          :style="{ gridTemplateColumns: `repeat(${persons.length}, minmax(45px, 200px)) 1fr 40px` }">
          <template v-for="person in persons">
            <ovp-pw-tab
              :key="person.personId"
              :person="person"
              :selected="person.personId === personId"
              @select="$personId => $emit('select', $personId)"
            />
          </template>

          <div />

          <div class="tabs-tab tabs-tab--minimized">
            <ovp-icon
              class="tabs-tab__edit"
              art="light"
              name="pencil"
              @click="$emit('open')"
            />
          </div>
        </div>
      </transition>
    </template>

    <template v-else>
      <div class="tabs-empty">
        <div v-text="$t('screen.priceWidget.widget.empty.description')" />

        <ovp-button
          primary
          @click="$emit('open')"
          v-text="$t('screen.priceWidget.widget.empty.button')"
        />
      </div>
    </template>
  </div>
</template>

<script>
import OvpPwTab from '@/modules/PriceWidget/components/Header/Tab'

export default {
  name: 'Tabs',

  components: {
    OvpPwTab,
  },

  props: {
    personId: {
      type: String,
      default: '',
    },

    persons: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      toggled: false,
    }
  },

  computed: {
    activePerson() {
      return this.persons.find(p => p.personId === this.personId)
    },
  },

  methods: {
    toggle() {
      this.toggled = !this.toggled
    },
  },
}
</script>

<style name="animations" scoped>
.tabs {
  &-enter,
  &-leave-to {
    transform: scaleY(0);
  }

  &-enter-active,
  &-leave-active {
    transition: transform 0.3s ease-in-out;
    transform-origin: top;
  }
}
</style>

<style name="mobile" scoped>
.tabs {
  display: flex;
  flex-direction: column;
  user-select: none;
  position: relative;
  max-width: 100%;

  &--empty {
    background-color: var(--c-white);
  }

  &-person {
    position: relative;
    background-color: var(--c-white);
    border-bottom: 1px solid var(--c-gray);

    .icon {
      position: absolute;
      right: 15px;
      top: 10px;
      font-size: 30px;
    }
  }

  &-list {
    display: flex;
    flex-direction: column;
    z-index: 2;
    position: absolute;
    top: 50px;
    width: 100%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    background-color: var(--c-white);

    & >>> .tab {
      max-width: initial;
      border-bottom: 1px solid var(--c-gray);

      &:first-child {
        border-top: 1px solid var(--c-gray);
      }
    }
  }

  &-tab {
    background-color: var(--c-white);
    padding: 15px;
    text-align: center;

    &--minimized {
    }

    &__edit {
      cursor: pointer;
    }
  }

  &-empty {
    padding: 10px;

    div:first-child {
      font-weight: bold;
      font-size: 15px;
      line-height: 20px;
    }

    .button {
      margin: 10px 0 0 0;
      font-weight: bold;
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .tabs {
    &--empty {
      grid-template-columns: 1fr 250px;
      grid-template-rows: 50px;
      font-size: 15px;
      padding: 15px;

      color: var(--c-black);

      font-weight: bold;

      div:first-child {
        padding: 10px;
      }
    }

    &-person {
      display: none;
    }

    &-tab {
      padding: 10px;
      background-color: transparent;
    }

    &-list {
      position: initial;
      box-shadow: none;
      display: grid;
      grid-gap: 15px;
      grid-template-rows: 40px;
      background-color: transparent;

      & >>> .tab {
        max-width: initial;
        border: none;

        &:first-child {
          border: none;
        }
      }
    }

    &-empty {
      padding: 0;

      div:first-child {
        font-weight: bold;
        font-size: 15px;
        line-height: 20px;
      }

      .button {
        margin: initial;
      }
    }
  }
}
</style>
